// extracted by mini-css-extract-plugin
export default {"container":"OtimizacaoResultado_container__-iklo"};